import {useMemo} from 'react';
import {useTimesheetColumnEyeOptions} from './useTimesheetColumnEyeOptions';
import {Column} from '../TimesheetTableContext';

export function useVisibleTimesheetTableColumns(columnDefinitions: Column[]): Column[] {
	const {eyeOptions} = useTimesheetColumnEyeOptions();

	const columns: Column[] = useMemo(
		() =>
			columnDefinitions.filter(column =>
				column.toggleable
					? eyeOptions.some(eyeOption => eyeOption.name === column.id && eyeOption.checked)
					: column.visible
			),
		[columnDefinitions, eyeOptions]
	);

	return columns;
}
